export const getCreateCLConfig = () => {
    const config = [
        {
            section: 'Calling List Details',
            fields: [
                {
                    title: "Calling List ID",
                    name: "id",
                    mandatory: true,
                    post: v => v && v.replace(/\s+/g, '')
                },
                {
                    title: "Name",
                    name: "name",
                    mandatory: true,
                },
                {
                    title: "Courses to include",
                    name: "incCourse",
                    type: 'list',
                    options: ['SOS', 'PTC', 'FEC']
                }
            ]
        }
    ]

    return config
}